import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { handleApiError } from './errorHandler';

export class BaseApiClient {
  constructor(
    protected readonly discoveryApi: DiscoveryApi,
    protected readonly fetchApi: FetchApi,
    protected readonly serviceName: string = 'cloudbuild',
  ) {}

  protected async post<T>(path: string, body: any): Promise<T> {
    const baseUrl = `${await this.discoveryApi.getBaseUrl(this.serviceName)}/`;
    const url = new URL(path, baseUrl);

    const response = await this.fetchApi.fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      await handleApiError(response);
    }

    return response.json() as Promise<T>;
  }
}
